import { render, staticRenderFns } from "./denyReasonConfig.vue?vue&type=template&id=65b81c87&scoped=true"
import script from "./denyReasonConfig.vue?vue&type=script&lang=js"
export * from "./denyReasonConfig.vue?vue&type=script&lang=js"
import style0 from "./denyReasonConfig.vue?vue&type=style&index=0&id=65b81c87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b81c87",
  null
  
)

export default component.exports